import { Component, Input } from '@angular/core';
import { LoginJourney } from '../login-sca-enums';
import { OtpChannel } from '../../../services/strong-customer-authentication/model';
import {
  LoggedOutEntitlement,
  LoggedOutEntitlementsService,
} from '../../../services/logged-out-entitlements.service';
import { LinkItem } from '../../../models/common';
import { BrandService } from '../../../services/brand.service';
import { ContentService } from '../../../services/content.service';
import { AnalyticsService } from '../../../services/analytics.service';
import { GTMTracking } from '../../../enums/google-analytics-tracking';

@Component({
  selector: 'left-side-descriptions',
  templateUrl: './left-side-descriptions.component.html',
})
export class LeftSideDescriptions {
  @Input() step: LoginJourney;
  @Input() registerLink: LinkItem;
  @Input() mobileNumberEnding: string;
  @Input() homeNumberEnding: string;
  @Input() selectedOTPChannel: OtpChannel;
  LoginJourney: typeof LoginJourney = LoginJourney;
  OtpChannel: typeof OtpChannel = OtpChannel;
  registrationAllowed: boolean;
  headerName: string;
  bodyContent: string;
  private isOwnBrand: boolean;
  private brand: string;

  constructor(
    private analyticsService: AnalyticsService,
    private readonly loggedOutEntitlementsService: LoggedOutEntitlementsService,
    private readonly brandService: BrandService,
    private readonly contentService: ContentService
  ) {}

  async ngOnInit() {
    this.registrationAllowed =
      await this.loggedOutEntitlementsService.hasEntitlement(
        LoggedOutEntitlement.registrationPages
      );
    this.loadContent();
  }

  private async loadContent() {
    await this.checkBrand();

    if (this.isOwnBrand) {
      this.headerName = 'Online Account Manager';
      this.bodyContent =
        'Manage your account with the Online Account Manager any time, any place.';
    } else if (this.brand === 'Amazon') {
      this.headerName = 'Amazon Mastercard Online Account Manager';
      this.bodyContent =
        'Manage your account with the Amazon Mastercard online account manager - anytime, any place.';
    } else {
      this.headerName = `${this.brand} Online Account Manager`;
      this.bodyContent = `Manage your account with the ${this.brand} online account manager - anytime, any place.`;
    }
  }

  private async checkBrand() {
    const content = await this.contentService.getData();
    this.brand = content.global.brandName;
    this.isOwnBrand = this.brandService.isOwnBrand(
      this.brandService.getBrand()
    );
  }

  onClickRegisterLink() {
    this.analyticsService.trackCtaActions(GTMTracking.LoginSignUpHereClick);
  }
}
